const attachmentRegistry = new Map();
export function registerOrbStreamAttachment(name, attachment) {
    attachmentRegistry.set(name, attachment);
}
export function attachNamedStreamBetweenOrbs(name, scene, sourceOrb, targetOrb) {
    const attachment = attachmentRegistry.get(name);
    if (!attachment) {
        return false;
    }
    attachment.attachBetweenOrbs(scene, sourceOrb, targetOrb);
    return true;
}
